export function get_percentage(value: number, total: number): number {
  return Number(Number((value * 100) / total).toFixed(2));
}
